import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
// @ts-expect-error pure js
import axios from "../../api";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
// @ts-expect-error pure js
import { getPromoCode, getUtmParams } from "../../utils";
import { signupTrackingFields } from "../../utils/tracking";
// @ts-expect-error pure js
import useAuth from "../../hooks/use-auth.js";
import styles from "./GoogleAuth.module.css";

interface GoogleAuthProps {
  persistLogin?: boolean;
}

export default function GoogleAuth({ persistLogin = false }: GoogleAuthProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { buildAndSetAuth } = useAuth();
  const from =
    (location.state?.from?.pathname ?? "/") +
    (location.state?.from?.search ?? "");
  const [searchParams] = useSearchParams();
  const idParrain = searchParams.get("referral") || location.state?.referral;
  const utm = getUtmParams(searchParams) || location.state?.utm;
  const codePromo = getPromoCode(searchParams) || location.state?.promo;

  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID}>
      <div className={styles.container}>
        <GoogleLogin
          width="375"
          onSuccess={async (credentialResponse) => {
            try {
              const response = await axios.post(
                `${import.meta.env.VITE_BACKEND_URL}/signup/google`,
                {
                  token: credentialResponse.credential,
                  id_parrain: idParrain,
                  code_promo_inscription: codePromo,
                  utm,
                  ...signupTrackingFields(searchParams),
                  persist_login: persistLogin,
                },
              );
              buildAndSetAuth(response.data);
              navigate(
                response.data.home === "/tbd" ? response.data.home : from,
                { replace: true },
              );
            } catch (err: unknown) {
              const error = err as { response?: { status: number } };
              if (error.response?.status !== 401) {
                console.error(err);
              }
            }
          }}
        />
      </div>
    </GoogleOAuthProvider>
  );
}
